import React, { ButtonHTMLAttributes } from 'react';
import cn from 'classnames';
import IntegrationIcons from '@repo/icons/IntegrationIcons';
import styles from './Buttons.module.scss';
import StateBasedFadeTransition from '@components/transitions/StateBasedFadeTransition';
import { LoaderIcon } from '@repo/icons';
import { LoginButton } from '@repo/components/buttons';

interface CustomButtonProps {
  onClick: React.MouseEventHandler;
  inProgress: boolean;
  isSignUp?: boolean;
  disabled?: boolean;
  className?: string;
  showLastUsedTag?: boolean;
}

export function ToggleButton({
  className,
  onClick,
  disabled,
  children,
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(styles.toggleBtn, className)}
      disabled={disabled}
    >
      {children}
    </button>
  );
}

const buttonActionText = (inProgress: boolean, isSignUp: boolean) => {
  let label = 'Sign in';

  if (isSignUp) {
    label = 'Continue';
  }

  if (inProgress && !isSignUp) {
    label = 'Signing in';
  }

  if (inProgress && isSignUp) {
    label = 'Continuing';
  }

  return label;
};

export function GoogleLoginButton({
  onClick,
  inProgress,
  isSignUp,
  disabled,
  showLastUsedTag,
}: CustomButtonProps) {
  return (
    <LoginButton
      onClick={onClick}
      disabled={disabled}
      showLastUsedTag={showLastUsedTag}
      className={cn(styles.button, styles.googleBtn)}
    >
      <IntegrationIcons.google width={18} height={18} customColor="#fff" />
      {buttonActionText(inProgress, isSignUp)}{' '}
      {inProgress ? <LoaderIcon customColor="#fff" /> : 'with Google'}
    </LoginButton>
  );
}

export function AppleLoginButton({
  onClick,
  inProgress,
  isSignUp,
  disabled,
  showLastUsedTag,
}: CustomButtonProps) {
  return (
    <LoginButton
      onClick={onClick}
      disabled={disabled}
      className={cn(styles.button, styles.appleBtn)}
      showLastUsedTag={showLastUsedTag}
    >
      <IntegrationIcons.apple width={18} height={21} />
      {buttonActionText(inProgress, isSignUp)} {inProgress ? <LoaderIcon /> : 'with Apple'}
    </LoginButton>
  );
}

export function EmailLoginButton({
  onClick,
  inProgress,
  isSignUp,
  disabled,
  className,
}: CustomButtonProps) {
  const btn = (
    <LoginButton
      className={cn(styles.emailBtn, className)}
      onClick={onClick}
      disabled={disabled || inProgress}
    >
      {buttonActionText(inProgress, isSignUp)}{' '}
      {inProgress ? <LoaderIcon customColor="#fff" /> : 'with email'}
    </LoginButton>
  );

  return (
    <StateBasedFadeTransition
      state={String(isSignUp)}
      elementByStateMap={{
        true: <span>{btn}</span>,
        false: <span>{btn}</span>,
      }}
      duration="slow"
    />
  );
}
